__turbopack_context__.v({
  "balance": "wallet-selector-module-sass-module__SH_enW__balance",
  "bonusLabel": "wallet-selector-module-sass-module__SH_enW__bonusLabel",
  "bonusWallet": "wallet-selector-module-sass-module__SH_enW__bonusWallet",
  "currency": "wallet-selector-module-sass-module__SH_enW__currency",
  "customDropdown": "wallet-selector-module-sass-module__SH_enW__customDropdown",
  "dropdownList": "wallet-selector-module-sass-module__SH_enW__dropdownList",
  "loader": "wallet-selector-module-sass-module__SH_enW__loader",
  "opened": "wallet-selector-module-sass-module__SH_enW__opened",
  "selected": "wallet-selector-module-sass-module__SH_enW__selected",
  "typeBonus": "wallet-selector-module-sass-module__SH_enW__typeBonus",
});
